import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { name: "Home", path: "/", testid: "nav-home-link" },
  { name: "About Us", path: "/about", testid: "nav-about-link" },
  { name: "Security", path: "/security-systems", testid: "nav-security-link" },
  { name: "ELV", path: "/elv-systems", testid: "nav-elv-link" },
  { name: "PA & AV", path: "/pa-av-systems", testid: "nav-pa-av-link" },
  { name: "Why Us", path: "/why-choose-us", testid: "nav-why-us-link" },
  { name: "Contact", path: "/contact", testid: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-slate-900/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
            <img
              src="/assets/yc-icon.png"
              alt="YC SYSTEM logo"
              className="w-11 h-11 object-cover rounded-sm border border-cyan-400/30"
            />
            <div className="leading-tight">
              <div className="font-display text-white text-lg font-bold tracking-tight">YC SYSTEM</div>
              <div className="tech-label !text-[0.55rem]">Security &amp; AV Integrator</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.path}
                to={l.path}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-medium transition-colors ${
                    isActive ? "text-cyan-400" : "text-slate-300 hover:text-white"
                  }`
                }
              >
                {l.name}
              </NavLink>
            ))}
            <Link
              to="/quote"
              data-testid="nav-quote-button"
              className="ml-3 px-5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold transition-colors border border-cyan-400/40"
            >
              Request a Quote
            </Link>
          </nav>

          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-slate-900/95 border-t border-white/10" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.path}
                to={l.path}
                data-testid={`mobile-${l.testid}`}
                className={({ isActive }) =>
                  `px-3 py-3 text-base font-medium border-l-2 transition-colors ${
                    isActive
                      ? "text-cyan-400 border-cyan-400 bg-cyan-400/5"
                      : "text-slate-300 border-transparent hover:text-white"
                  }`
                }
              >
                {l.name}
              </NavLink>
            ))}
            <Link
              to="/quote"
              data-testid="mobile-nav-quote-button"
              className="mt-3 px-5 py-3 bg-blue-600 text-white text-center font-semibold border border-cyan-400/40"
            >
              Request a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
